/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import moment from 'moment';

import BaseGrid from '../../components/Common/BaseGrid';

function ElasticSearch(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  document.title = 'Elastic Search Utility';

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="9">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Search Partner API')}
              </CardHeader>
              <CardBody>
                <BaseGrid
                  url="/api/es/partner-api"
                  hasSearch
                  className="table table-sm table-hover table-bordered fs-6"
                  config={
                  {
                    columns: {
                      thumb: {
                        label: '',
                        image: {
                          src: (listing) => (`/api/listings/thumbnail/${listing.id}`),
                          class: 'rounded',
                          style: { maxHeight: '6rem', maxWidth: '6rem' },
                        },
                        translate: false,
                      },
                      id: {
                        label: 'ID',
                        sort: true,
                        style: { minWidth: '100px' },
                        link: {
                          to: '/listing/%id%',
                        },
                      },
                      sku: {
                        label: 'Sku',
                        sort: true,
                      },
                      title: { label: 'Title', sort: true, style: { fontSize: '11px', maxWidth: '200px' } },
                      condition: { label: 'Condition', sort: true, style: { fontSize: '11px' } },
                      price: {
                        label: 'Price',
                        sort: false,
                        format: (x) => new Intl.NumberFormat(
                          'en-US',
                          {
                            style: 'currency',
                            currency: 'USD',
                          },
                        ).format(x),
                        style: { fontSize: '11px' },
                      },
                      last_qty: {
                        label: 'Qty for Sale',
                        sort: true,
                        style: { fontSize: '11px' },
                      },
                      created_at: {
                        label: props.t('Created'),
                        date: {
                          format: (date) => (moment(date).fromNow()),
                          timezone: process.env.LOCAL_TZ,
                        },
                        sort: true,
                        style: { fontSize: '11px' },
                      },
                    },
                    pagination: {
                      sort: 'id',
                      direction: 'desc',
                      perPage: 30,
                    },
                  }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

ElasticSearch.defaultProps = {
  t: (x) => (x),
};

ElasticSearch.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ElasticSearch));
